<template>
  <GsaEditor 
    :gsa="gsa"
    edit
  />
</template>

<script>
import GsaEditor from '../components/GsaEditor.vue'

export default {
  computed:{
    gsa_id(){
      return this.$route.params.gsa_id
    },
    gsa(){
      return this.$store.getters.gsa(this.gsa_id)
    }
  },
  components:{
    GsaEditor
  }
}
</script>